module.exports = "<div class=\"card\">\n  <h4 class=\"card-header\">\n    <a href=\"https://github.com/fzred/calculatorjs/blob/HEAD/README-ZH.md\">Calculatorjs <i class=\"fa fa-external-link\"></i></a>\n  </h4>\n  <div class=\"card-body\">\n    <iw-dynamic-form #form [controls]=\"controls\" [classBtnSubmit]=\"'btn-primary'\" [valueBtnSubmit]=\"'Submit'\"\n      [hardReset]=\"true\" [disableReset]=\"true\" (sended)=\"calculate($event)\">\n    </iw-dynamic-form>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/examples/calculatorjs/calculatorjs.component.html
// module id = ./src/app/examples/calculatorjs/calculatorjs.component.html
// module chunks = main